import AddEditProposalLineItemContent from '@/ui/components/addEditProposalLineItem/AddEditProposalLineItemContent';
import { Button } from '@payaca/ambrosia';
import { FC, useState } from 'react';
import { EstimateLineItem } from '../types';
import useEstimateLineItemEditor from './useEstimateLineItemEditor';

type EstimateItemEditorProps = {
  projectId: string;
  estimateId: string;
  lineItem: EstimateLineItem;
  onBack: () => void;
};

/**
 * Inline Estimate Line Item editor for the Estimate Builder. Reuses the shared
 * Proposal line item editor in autosave mode, with thumbnails hidden (the
 * Estimate template doesn't render them) and multi-choice/optional selection
 * omitted (all Estimate lines are required).
 */
const EstimateItemEditor: FC<EstimateItemEditorProps> = (props) => {
  const { projectId, estimateId, lineItem, onBack } = props;

  const [isLinkMaterialSidebarOpen, setIsLinkMaterialSidebarOpen] =
    useState(false);

  const { lineItemData, isSubmitting, onSubmit, onThumbnailDelete, onDelete } =
    useEstimateLineItemEditor({
      projectId,
      estimateId,
      lineItem,
      onRemoveSuccess: onBack,
    });

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="p-3.5 pb-2.5">
        <Button onClick={onBack} variant="quaternary" size="sm">
          Back to items
        </Button>
      </div>

      <div className="min-h-0 flex-1">
        <AddEditProposalLineItemContent
          saveMode="autosave"
          rootPage="estimate"
          showThumbnail={false}
          isSaving={isSubmitting}
          proposalLineItemId={lineItem.id}
          proposalLineItemData={lineItemData}
          isLinkMaterialSidebarOpen={isLinkMaterialSidebarOpen}
          setIsLinkMaterialSidebarOpen={setIsLinkMaterialSidebarOpen}
          onSubmit={onSubmit}
          onThumbnailDelete={onThumbnailDelete}
          onDelete={onDelete}
        />
      </div>
    </div>
  );
};

export default EstimateItemEditor;
